/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2023-02-16 19:45:33
 * @LastEditors: suzhen@dainzhong.com
 * @LastEditTime: 2026-03-03 16:24:55
 * @Description  : 文件简介
 */
import { createApp } from 'vue'

// import 'vant/lib/index.css';
import './assets/styles/public.less'
import "./assets/styles/basic.css";
// import "./assets/styles/common.css";

import App from './App.vue'
import router from './router'
import store from './store'
import { setStorage, getStorage, getUserNum } from '@/utils/cookie.js'
import { randomStr, h5Log, os } from '@/utils'
import 'lib-flexible/flexible.js'
import ttNavHeader from '@/commponents/ttNavHeader.vue'

if(!getStorage('utdid')) {
    setStorage('utdid', randomStr())
}
setStorage('sessionid', randomStr(20))

import './permission.js'

// 预发布线上需要注释的代码
// import Vconsole from 'vconsole'
import * as vantComponents from './vantComponents'

var sensors = require('sa-sdk-javascript'); 
sensors.init({
  server_url: 'https://sc-sa.dzfread.cn/sa?project=xinmeiti_dj',
  is_track_single_page:true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time:true, 
  send_type:'beacon',
  show_log: false,
  heatmap: {
     //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
     clickmap: 'not_collect',
     //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
     scroll_notice_map:'default'
  }
});
sensors.registerPage({
    app_name: '天天悦读',
    os: os() == 0 ? 'android' : 'ios',
    pname: 'com.dianzhong.kocttyd',
    utdid: getStorage('utdid'),
    appid: 'ttyd',
    domain: 25,
    pline: '天天悦读',
    referral_id: '',
    session_id: getStorage('sessionid'),
    channel_id: ''
});
sensors.quick('autoTrack'); //用于采集 $pageview 事件。

if(getUserNum()) {
    sensors.login(getUserNum());
}

const app = createApp(App)
app.config.errorHandler = function (err, vm, info) {
    if(!vm) return false
    let filename = vm.$options.__file
    if(!filename){
        if(vm.$parent.$options.__file) filename='parent --- ' + vm.$parent.$options.__file
        else filename='parent --- ' + vm.$parent.$options.name
    }
    let err_obj = {
        message: err.message,
        errname: err.name,
        filename: filename || '未抓取',
        href: location.href,
        stack:  err.stack,
        mark: info + '---' + err.stack.split('\n')[1].split('(')[0].trim(),
    }
    console.log('错误触发上报机制', err)
    h5Log('page', 'err', 'event', err_obj)
}

// if (process.env.NODE_ENV !== 'production') {
//     const vConsole = new Vconsole()
//     app.use(vConsole)
// }

// app.config.globalProperties.$sensors = sensors
app.config.globalProperties.$sensors = (name, params = {}) => { // 神策打点
	if (process.env.NODE_ENV === 'production') {
        // ----------------服务关停-----------------------
        // 停止上报神策
        // sensors.track(name, params)
        // ----------------服务关停-----------------------
    } else {
        console.log('神策打点：' + name, params);
    }
    console.log(process.env.NODE_ENV, '神策打点：' + name, params);
}

// app.component('ttNavHeader',ttNavHeader).use(Button).use(List).use(Tabbar).use(TabbarItem).use(NavBar).use(Popup).use(VanImage).use(Loading).use(Overlay).use(PickerGroup).use(Sticky)
// .use(Field).use(CellGroup).use(Toast).use(Dialog).use(Tab).use(Tabs).use(Empty).use(Popover).use(ActionSheet).use(Progress).use(DropdownMenu).use(DropdownItem)
// .use(router).use(store).mount('#app')

// 自定义公共组件
app.component('ttNavHeader',ttNavHeader)
// vantUI插件
Object.values(vantComponents).forEach(plugin => app.use(plugin))

app.use(router)
app.use(store)

app.mount('#app')